export default __webpack_public_path__ + "6e4424ad699e61b023b463761f8cf111.png";